import { faListCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import {
  applicantModalAsideSection,
  applicantModalAsideSectionTitle
} from '~/components/Scopes/Applicants/ApplicantModal/ApplicantModal.css'
import { themeClass } from '~/styles/theme.css'
import type { AsideActionPosition } from '~/types/global'
import { useTasks } from '../../queries/tasks'
import { TaskCard } from '../TaskCard/TaskCard'
import { taskGridWithoutPersons } from '../TaskCard/TaskCard.css'

const MAX_TASKS = 10
const asidePositions: AsideActionPosition[] = ['bottom', 'modal']

/** Open tasks of a contact, soonest first, as standard task rows without the persons column. */
export const ContactTasks = ({
  contactId
}: {
  contactId: number
}): ReactElement | null => {
  const { data } = useTasks({
    contacts: [contactId],
    isCompleted: false,
    itemsPerPage: MAX_TASKS,
    enabled: contactId > 0
  })
  const tasks = data?.pages[0]?.['hydra:member'] ?? []

  if (tasks.length === 0) {
    return null
  }

  return (
    <div className={clsx(applicantModalAsideSection, themeClass)}>
      <div className={applicantModalAsideSectionTitle}>
        <FontAwesomeIcon icon={faListCheck} />{' '}
        {tasks.length > 1 ? 'Prochaines tâches' : 'Prochaine tâche'}
      </div>
      <div className={taskGridWithoutPersons}>
        {tasks.map((task) => (
          <TaskCard
            key={task.id}
            task={task}
            compact
            hidePersons
            dueDateAfterTitle
            asidePosition="bottom"
            asideAvailablePositions={asidePositions}
          />
        ))}
      </div>
    </div>
  )
}
